import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ModalDirective } from '@shared/directives/modal.directive';
import { priorities, recurringPriorities, recurringPrioritiesFR, roleTypes } from '@shared/helpers/types.helper';
import { IPayload } from '@shared/interfaces/payload.interface';
import { IUser } from '@shared/interfaces/user.interface';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { LoggerService } from '@shared/services/logger.service';
import { ILocation } from '@shared/interfaces/location.interface';
import { ToastService } from '@shared/services/toast.service';
import { UsersService } from '@shared/services/users.service';
import jwtDecode from 'jwt-decode';
import { NgxSelectOption } from 'ngx-select-ex';
import { forkJoin, noop, Subject } from 'rxjs';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { IContact } from '@shared/interfaces/contact.interface';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ContactsService } from '@shared/services/contacts.service';
import { ICompany } from '@shared/interfaces/company.interface';
import { LocationsService } from '@shared/services/locations.service';
import { ILibrary } from '@shared/interfaces/library.interface';
import { UploadOutput } from 'ngx-uploader';
import { IPicture } from '@shared/interfaces/picture.interface';
import { PicturesService } from '@shared/services/pictures.service';
import { LibrariesService } from '@shared/services/libraries.service';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { IEmail } from '@shared/interfaces/email.interface';
import { EmailsService } from '@shared/services/emails.service';
import { Editor, Toolbar } from 'ngx-editor';
import { TranslateService } from '@ngx-translate/core';
import {
  issuesStatus,
  issuesStatusFR,
  prioritiesFR
} from '@shared/helpers/types.helper';
import { IIssue } from '@shared/interfaces/issue.interface';
import { IssuesService } from '@shared/services/issues.service';
import { PaginationIssuesService } from '@shared/services/pagination/pagination.issues.service';

@Component({
  selector: 'app-modals-issues',
  templateUrl: './modals.issues.component.html',
  styleUrls: ['./modals.issues.component.scss'],
})
export class ModalsIssuesComponent
  extends ModalDirective<any>
  implements OnInit {
  @Input() public openModal: Subject<any>;
  @ViewChild('form', { static: false }) form: NgForm;
  @Input() public afterClose?: () => any = noop;
  public title = String('COMMON.ISSUES');
  public description = String('COMMON.ISSUES');
  public emailTestTooltipMessage = "";
  public submitKey = String('BUTTONS.SUBMIT');
  public subject = String('');
  public body = String('');
  public toEmails: any = [];
  public disableButtons = Boolean(false);
  public issuesStatus: { label: string; value: string }[] = issuesStatus;
  public isLoading = Boolean(false);
  public entry: FormGroup;
  public roles: { value: number; label: string }[] = roleTypes;
  public role: number;
  public contacts: Partial<IContact>[] = [];
  public items: any[] = [];
  public locations: Partial<ILocation>[] = [];
  public uploadImages: any[] = [];
  public subLocations: Partial<ILocation>[] = [];
  public file: File;
  public isEditing = Boolean(false);
  public files: NgxFileDropEntry[] = [];
  public documentList: any[] = [];
  public documentListLabels: any[] = [];
  public filesToUpload: NgxFileDropEntry[] = [];
  public isUploading = Boolean(false);
  public isOpen = Boolean(false);
  public showDeviceFiles = Boolean(false);
  public fgSelected: FormGroup;
  public showFields = new FormControl(false);
  public pictureSelected: string;
  public userId: string;
  public id = String('');
  public timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  public startDate: string;
  public priorities: { label: string; value: string }[] = recurringPriorities;
  public subLocationsFilters: any[] = [
    {
      key: 'pagination',
      value: false
    }
  ];
  public modules: any = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link']
    ]
  };

  public editor: Editor;
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  public defaultSubLocationValue: string;
  public availableEmails = [

  ];
  public errorMessages = {
    pattern: 'Email must be in format abc@abc.com',
  };
  public config: any = {
    class: 'modal-lg'
  };
  public dataModel: any;
  public editorTextCount = 0;
  public isSubmitted = false;
  public isFieldEmpty = false;
  public libraryList: any[] = [];
  public isMaxLengthLimitReached = false;
  public bsValue = moment().startOf('day').toDate();
  public closeModal: Subject<any> = new Subject<any>();

  public bsConfig: any = {
    containerClass: 'ohq-datepicker',
    dateInputFormat: 'MMMM DD YYYY',
    showWeekNumbers: false,
    adaptivePosition: true,
    minDate: moment(new Date()).toDate(),
    minMode: 'day'
  };
  public config2: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '200px',
    width: 'auto',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Search for Occupants emails',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['customClasses', 'insertImage', 'insertVideo', 'toggleEditorMode'],
    ],
  };
  public formDetails = {
    subject: '',
    body: '',
  };
  private readonly constructorName: string = String(this.constructor.name);
  private blob: Blob;
  constructor(
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _fb: FormBuilder,
    private readonly _logger: LoggerService,
    public readonly _locations: LocationsService,
    public readonly _emails: EmailsService,
    private readonly _pictures: PicturesService,
    private readonly _users: UsersService,
    private readonly _issues: IssuesService,
    private readonly _contacts: ContactsService,
    private readonly _toasts: ToastService,
    public readonly _libraries: LibrariesService,
    public dom: DomSanitizer,
    private readonly _translate: TranslateService,
    private readonly __paginationIssues: PaginationIssuesService
  ) {
    super();

    this.onGetValueFromAttributes = this.onGetValueFromAttributes.bind(this);
    this.onGetValueFromAttributesLocation = this.onGetValueFromAttributesLocation.bind(this);
  }


  ngOnInit(): void {
    const payload: IPayload = jwtDecode(this._commonEnvironments.getToken());
    this.userId = payload.id;
    
    this.role = Number(payload.role);

    this.createForm(); 
    // this.getDocuments();     

    this.openModal.subscribe((e: IIssue) => {
      const payload: IPayload = jwtDecode(this._commonEnvironments.getToken());

      if (e) {
        this.title = 'MODALS.ISSUES.EDIT.TITLE';
        this.description = 'MODALS.ISSUES.EDIT.DESCRIPTION';
        this.entry.patchValue({ ...e});
        // this.libraryList = e?.pictures.map( item => {
        //   return {
        //     type: 'image/jpeg',
        //     ...item

        //   }
        // })

      } else {
        this.title = 'MODALS.ASSETS.ADD.TITLE';
        this.description = 'MODALS.ASSETS.ADD.DESCRIPTION';
      }
    });

    this._translate.onLangChange.subscribe((event) => {
      const isFrench = event.lang === 'fr';
      this.issuesStatus = isFrench ? issuesStatusFR : issuesStatus;
      this.priorities = isFrench ? recurringPrioritiesFR : recurringPriorities;
    });

  }

  public getDocuments() {
    this.isLoading = true;
    // TODO FIX USE THE RIGHT FILTERS
    this._libraries
      .get(1, [
        {
          key: 'limit',
          value: 300
        }
      ])
      .subscribe((res) => {
        this.isLoading = false;
        this.documentList = res;
        this.documentListLabels = res.map((res2) => res2.label);
      });
  }

  public onGetValueFromAttributes(e: ICompany) {
    return e.name;
  }

  public onGetValueFromAttributesLocation(e: ILocation) {
    return e.label;
  }

  public removePicture(i: number) {
    this.filesToUpload.splice(i, 1);
    this.files.splice(i, 1);
    this.uploadImages.splice(i, 1);
  }

  public openConfirmModal(fg: FormGroup, id: string) {
    this.fgSelected = fg;
    this.pictureSelected = id;
  }

  public isImage(filename) {
    return filename.split('.').pop() == 'jpg' ||
      filename.split('.').pop() == 'png' ||
      filename.split('.').pop() == 'jpeg'
      ? true
      : false;
  }

  public isImageType(type) {
    const imageTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/bmp'
    ];
    return imageTypes.includes(type);
  }

  public openUpload() {
    const el = document.getElementsByClassName('upload-files-tasks')[0] as any;
    el?.click();
  }

  public removeUplodedDocument(id: string) {
    this.libraryList = this.libraryList.filter(item => item.id !== id);
    this.documentList = this.documentList.filter(item => item.id !== id);
    this.entry.patchValue({
      documents: [...this.entry.get('documents').value.filter(item => item !== id)],
      documentList: [...this.entry.get('documentList').value.filter(item => item !== id)],
    });
  }

  public uploadFiles(files: NgxFileDropEntry[]) {
    this.filesToUpload = [...this.filesToUpload, ...files];
    this.errors = [];
    this.isUploading = true;
    for (const f of files) {
      if (f.fileEntry.isFile) {
        const fileEntry = f.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file.size < 20000000) {
            this.file = file;
            this.files = [...this.files, this.file as any];
            this.uploadImages.push(URL.createObjectURL(file));
            if (this.entry.get('fileNames').value) {
              this.entry.patchValue({
                fileNames: [...this.entry.get('fileNames').value, file.name]
              });
            } else {
              this.entry.patchValue({
                fileNames: [file.name]
              });
            }
          } else {
            this._toasts.error(`Sorry! The file named "${file.name}" exceeds the maximum allowable size of 20MB. Please upload a smaller file to proceed.`);
          }
        });
        this.isUploading = false;
      } else {
        this._toasts.error('Not a file');
        this.isUploading = false;
      }
    }
  }



  public onDismiss() {
    this.afterClose();
  }
  

  public onSubmit({ value, valid }: { value: any; valid: boolean }): void {
    if (valid) {
      let method = 'post';
      let url = `${method.toUpperCase()} /assets`;
      if (value.id) {
        method = 'patch';
        url = `${method.toUpperCase()} /assets/${value.id}`;
      }
      value = this.entry.getRawValue();

      this.createAndUpdateAsset(value, method, url);
     
      // let promises = [];
      // this.filesToUpload.forEach((f) => {
      //   if (f.fileEntry.isFile) {
      //     const fileEntry = f.fileEntry as FileSystemFileEntry;
      //     fileEntry.file((file: File) => {
      //       const filters: any = [
      //         {
      //           key: 'label',
      //           value: file.name
      //         }
      //       ];
      //       promises.push(this._libraries.postLibrary(file, filters));
      //     });
      //   }
      // });
      // if (this.filesToUpload.length > 0) {
      //   forkJoin(promises).subscribe(
      //     (resDocs) => {
      //       this.isUploading = false;
      //       promises = [];

      //       if (!value?.pictures) {
      //         value.pictures = [];
      //       }

      //       value.pictures = [...value?.pictures, ...resDocs.map((item: ILibrary) => item.id), ...value.documentList];
      //       this.createAndUpdateAsset(value, method, url);
      //     },
      //     (error) => {
      //       this._toasts.error('Upload has failed!');
      //       console.error(error.message);
      //     }
      //   );
      // } else {
      //   if (!value?.pictures) {
      //     value.pictures = [];
      //   }
      //   value.pictures = [...value?.pictures, ...value.documentList];
      //   this.createAndUpdateAsset(value, method, url);
      // }
    }
  }

  public createAndUpdateAsset(value, method, url) {
    this.disableButtons = true;
    this.entry.disable();

    this._issues[method](value).subscribe(
      (res: IIssue) => {
        this._logger.info(this.constructorName, url, res);
        this.entry.enable();
        this.entry.reset();
        this.disableButtons = false;
        this.id = res.id;
        if (method === 'post') {
          this._toasts.success('Issue successfully created!');
        } else if (method === 'patch') {
          this._toasts.success('Issue successfully updated!');
        }

        this.__paginationIssues.reloadPage(1);
        this.createForm();
        this.closeModal.next();
      },
      (err: any) => {
        this._logger.error(this.constructorName, url, err);
        const errors = err.errors;
        if (errors) {
          this.errors = errors;

          if (errors[0].detail) {
            this._toasts.error(errors[0].detail);
          }
        }

        this.entry.enable();
        this.disableButtons = false;
      }
    );
  }


  protected createForm() {
    this.entry = this._fb.group({
      status: [''],
      id: [''],
      files: [''],
      fileNames: [''],
      pictures: [[], []],
      documentList: [[], []],
      documents: [[], []],
      priority: [''],
      comment: ['']
    });
  }

  private setDefaultValues() {
    this.disableButtons = false;

    this.items = [];
    this.files = [];
    this.documentList = [];
    this.documentListLabels = [];
    this.uploadImages = [];
    this.libraryList = [];
    this.uploadImages = [];
    this.filesToUpload = [];
    this.entityForm.reset();
    this.errors = [];
    // this.createForm();
    this.entry.enable();
    
  }


}
